import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Card = styled.div`
  box-shadow: 0 0 12px rgba(0, 0, 0, .3);
  
  ${({ styles: { margin, padding, maxWidth, background, borderRight } }) => css`
    margin: ${margin};
    padding: ${padding};
    max-width: ${maxWidth};
    background: ${background || '#fff'};
    border-right: ${borderRight};
  `}
`;

export default Card;
